import {
  Building2,
  Cog,
  Truck,
  Recycle,
  ClipboardList,
  Server,
  Thermometer,
  ShieldCheck,
  Lightbulb,
  WashingMachine,
  Droplets
} from "lucide-react";

export const DEPT_ICONS = {
  building_facilities: Building2,
  operations_equipment: Cog,
  transportation_logistics: Truck,
  procurement_waste: Recycle,
  administrative: ClipboardList,
  it_infrastructure: Server,
  res_hvac: Thermometer,
  res_insulation: ShieldCheck,
  res_lighting: Lightbulb,
  res_appliances: WashingMachine,
  res_water_heating: Droplets,
};

export const CHART_COLORS = ["#244C36", "#C86B4F", "#397A55", "#D99C41", "#427B9B"];

export const LIVE_CHART_COLORS = ["#244C36", "#3B82F6", "#C86B4F", "#D69E2E", "#7C3AED", "#059669"];
